import { render, staticRenderFns } from "./MicroSetting.vue?vue&type=template&id=53957c14&"
import script from "./MicroSetting.vue?vue&type=script&lang=js&"
export * from "./MicroSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MicroSetting.vue"
export default component.exports